export function mapProfileFromDb(dbRow) {
  return {
    avatarUrl: dbRow.avatar_url,
    id: dbRow.id,
    fullName: dbRow.full_name,
    email: dbRow.email,
    status: dbRow.status,
    onboardingStatus: dbRow.onboarding_status
  }
}
